"use client";

import Header from "@/components/Layouts/Header";
import { useHeader } from "@/context/HeaderLayoutContext";

export default function HeaderWrapper() {
  const { headerStyle } = useHeader();

  return (
    <div style={{ position: "fixed", top: "0px", left: "0px", zIndex: 1000, width: "100%" }}>
      <Header isTransparent={headerStyle.transparent} />
    </div>
  );
}
